import styled from 'styled-components'
import { Form } from 'antd'

export const FormLabelLeftStyle = styled(Form)`
  .ant-form-item-label {
    text-align: left;
  }
`
